import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { bonuses } from '../../data/bonuses';
export function BonusesDetail() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-32" data-mp="2a75uxr9tbpq5">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-33" data-mp="2a5mdhxcf78ms">
        <SectionTag icon="🎁" data-id="element-34" data-mp="2ey5oqnnmxrof">5 Bonos estratégicos incluidos</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-35" data-mp="2jwz3skiklqqp">
          Y además, recibes 5 bonos exclusivos.
        </h2>
        <p className="mt-4 text-base text-muted sm:text-lg" data-id="element-36" data-mp="2ou8stz21s0e0">
          Valor total de los bonos: <span className="text-white line-through" data-id="element-37" data-mp="2sy6p81zzmx3d">59,50€</span> →{' '}
          <span className="font-semibold text-orange" data-id="element-38" data-mp="2xvp1a19axsfl">Hoy: GRATIS con el sistema</span>
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-4xl gap-4 px-4 sm:px-6" data-id="element-39" data-mp="ykxoaylicjwq">
        {bonuses.map((bonus, i) => <m.div key={bonus.title} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.06
      }} className="flex flex-col gap-4 rounded-2xl border border-orange/20 bg-bg-primary p-6 sm:flex-row sm:items-start" data-id="element-40" data-mp="13j8xd73zaqdw" data-mpi={i}>
            <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-orange/10 text-2xl" data-id="element-41" data-mp="2xxwdcko22w8b">
              <span aria-hidden="true" data-id="element-42" data-mp="3umu5rw8c2i2b">{bonus.emoji}</span>
            </div>
            <div className="flex-1" data-id="element-43" data-mp="3qlipihbcn96s">
              <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-44" data-mp="3qmjymg8t1llv">
                <h3 className="font-heading text-base font-semibold text-white sm:text-lg" data-id="element-45" data-mp="3ll4ecqegbj4j">{bonus.title}</h3>
                <span className="text-sm" data-id="element-46" data-mp="3gncp6456yb41">
                  <span className="text-muted line-through" data-id="element-47" data-mp="2a7933sqo3uil">{bonus.value}</span>{' '}
                  <span className="font-semibold text-orange" data-id="element-48" data-mp="258fkxn0frfc3">GRATIS</span>
                </span>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-49" data-mp="26p362c1039q0">{bonus.text}</p>
            </div>
          </m.div>)}
      </div>

      <div className="mx-auto mt-6 max-w-2xl px-4 text-center sm:px-6" data-id="element-50" data-mp="2bo60z3n9nzk9">
        <p className="rounded-xl border border-orange/20 bg-orange/5 px-5 py-4 text-sm font-medium text-white sm:text-base" data-id="element-51" data-mp="1xpptvblhs71l">
          Si compras estos 5 bonos por separado: <span className="line-through text-muted" data-id="element-52" data-mp="1nz3khz4dccrc">59,50€</span> →{' '}
          <span className="text-orange" data-id="element-53" data-mp="1nxsj25yebh3e">Incluidos sin coste adicional</span>
        </p>
      </div>
    </section>;
}